/* @flow */

import * as React from 'react';
import {ButtonCard} from '../card/button-card';

import './two-line-button-card.css';

type Props = {
    children: React.Node,
    onClick?: () => void,
    isSelected?: boolean,
    isDisabled?: boolean,
};

TwoLineButtonCard.defaultProps = {
    as: 'button',
};

export function TwoLineButtonCard(props: Props) {
    const buttonCardStyle = {
        width: '100%',
        height: 'auto',
    };

    return (
        <ButtonCard
            style={buttonCardStyle}
            isSelected={Boolean(props.isSelected)}
            isDisabled={Boolean(props.isDisabled)}
        >
            <div
                styleName='two-line-button-card'
                type={props.onClick ? 'button' : undefined}
                onClick={props.onClick}
            >
                {props.children}
            </div>
        </ButtonCard>
    );
}
